import { useSelector } from "react-redux";

import { CurrentUserState } from "../ducks/currentUser";
import { RootState } from "../ducks/root";

const useCurrentUser = () => useSelector<RootState, CurrentUserState>(({ currentUser }) => currentUser);

export default useCurrentUser;
